<template>
    <select :name="name" :id="id" :disabled="disabled">
        <option></option>
    </select>
</template>

<script>
    import jQuery from 'jquery'
    import select2 from 'select2'

    export default {
        props: [
            'name',
            'id',
            'disabled',
            'placeholder',
            'options',
            'value',
            'ajax'
        ],
        mounted: function () {
            var self = this

            jQuery(this.$el)
                .select2({
                    theme: 'bootstrap',
                    width: '100%',
                    placeholder: this.placeholder,
                    data: this.options,
                    ajax: this.ajax,
                    allowClear: true,
                    templateSelection: function (data) { return data.text; },
                    templateResult: function (data) { return data.html; },
                    escapeMarkup: function(markup) {return markup;}
                })
                .val(this.value)
                .on('change', function(){
                    self.$emit('input', this.value)
                })
                .on('select2:close', function(){
                    jQuery(self.$el).focus()
                })
        },
        watch: {
            value: function (value) {
                this.$nextTick(() => {
                    jQuery(this.$el).val(value).trigger('change.select2')
                })
            },
            options: function (options) {
                jQuery(this.$el).select2().html('<option></option>');
                jQuery(this.$el).select2({
                    theme: 'bootstrap',
                    width: '100%',
                    placeholder: this.placeholder,
                    data: options,
                    allowClear: true,
                    ajax: this.ajax,
                    templateSelection: function (data) { return data.text; },
                    templateResult: function (data) { return data.html; },
                    escapeMarkup: function(markup) {return markup;}
                })
                .val(this.value)
                .trigger('change.select2')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Select2.vue?1196ee32